module.exports = __webpack_public_path__ + "static/easypdpa-d6646e6454a6a061c009a458c8629c10.svg";